// extracted by mini-css-extract-plugin
export default {"Feedback":"Feedback_Feedback__FbAtz"};